module.exports = __webpack_public_path__ + "img/Group4.2f76560c.svg";